import { render, staticRenderFns } from "./MediaFlat.vue?vue&type=template&id=085afed0&scoped=true&"
import script from "./MediaFlat.vue?vue&type=script&lang=js&"
export * from "./MediaFlat.vue?vue&type=script&lang=js&"
import style0 from "./MediaFlat.vue?vue&type=style&index=0&id=085afed0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085afed0",
  null
  
)

export default component.exports